'use client';

import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import styles from './form.module.css';

export const FormHead: FC<PropsWithChildren> = ({ children }) => <div className={styles['form-head']}>{children}</div>;

export const ContentBox: FC<PropsWithChildren> = ({ children }) => <div className={styles.box}>{children}</div>;

type FieldsetProps = PropsWithChildren & {
  className?: string;
  disabled?: boolean;
};

export const Fieldset: FC<FieldsetProps> = ({ children, className, disabled }) => (
  <fieldset className={classNames(styles.fieldset, className)} disabled={disabled}>
    {children}
  </fieldset>
);

type FormRowProps = PropsWithChildren & {
  desktopColumns: '1fr' | '1fr-1fr' | '1fr-2fr' | '1fr-3fr' | '2fr-1fr' | '3fr-1fr';
};

export const FormRow: FC<FormRowProps> = ({ children, desktopColumns }) => (
  <div className={classNames(styles.row, styles[`row-columns-${desktopColumns}`])}>{children}</div>
);
